export default __webpack_public_path__ + "static/logo-text-594d281e2e8664d743286086b6256984.png";